import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// 요청 인터셉터: 토큰 + userId 자동 추가
instance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('userId');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // 파일 업로드(FormData)는 스프레드하면 내용이 사라지므로 append 로 넣고
  // Content-Type 은 브라우저가 boundary 와 함께 붙이도록 비운다
  if (config.data instanceof FormData) {
    if (userId && !config.data.has('userId')) config.data.append('userId', userId);
    delete config.headers['Content-Type'];
    return config;
  }

  if (userId) {
    if (config.method === 'get') {
      config.params = { ...(config.params || {}), userId };
    } else if (['post', 'put', 'delete'].includes(config.method)) {
      config.data = { ...(config.data || {}), userId };
    }
  }

  return config;
}, (error) => Promise.reject(error));

// 응답 인터셉터: 401이면 토큰 만료
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('userId');
      localStorage.removeItem('userName');
      localStorage.removeItem('userRole');
      window.location.href = '/sena/login';
    }
    return Promise.reject(error);
  }
);

export default instance;